/**
 * GENERATED by apps/portal/scripts/es-rows.ts from docs/handoff/spanish/portal.csv — do not edit; rerun the script.
 * The reviewed Spanish (Evan's reviewer, 28 Sep) for the deck's plain strings, by the sheet's key.
 */
export const ES_ROWS: Readonly<Record<string, string>> = {
  "nav.approvals": "Aprobaciones",
  "nav.roster": "Lista de niños",
  "nav.redemptions": "Canjes",
  "nav.assignments": "Asignaciones",
  "nav.groupsCodes": "Grupos y códigos",
  "nav.settings": "Configuración",
  "shell.orgAdmin": "Admin. de la organización",
  "shell.poweredBy": "CON LA TECNOLOGÍA DE",
  "shell.kreditAcademy": "Kredit Academy",
  "shell.kiddieKredit": "Kiddie Kredit",
  "approvals.columns.child": "NIÑO O NIÑA",
  "approvals.columns.task": "TAREA",
  "approvals.columns.submitted": "ENVIADA",
  "approvals.columns.proof": "PRUEBA",
  "approvals.note": "Nota ▸",
  "approvals.photo": "Foto ▸",
  "roster.subtitle": "Inscritos por su madre o padre, con un consentimiento por niño. Ves el nombre, el avatar, el rango de edad y tus propias asignaciones.",
  "roster.searchPlaceholder": "Busca un nombre",
  "roster.emptyTitle": "Aún no hay familias",
  "roster.emptyBody": "Las familias aparecen aquí cuando se unen con tu código.",
  "roster.noMatches": "Ninguna familia coincide con esa búsqueda.",
  "roster.columns.child": "NIÑO O NIÑA",
  "roster.columns.ageBand": "RANGO DE EDAD",
  "roster.columns.groups": "GRUPOS",
  "roster.columns.tasksDone": "MIS TAREAS HECHAS",
  "roster.columns.score": "PUNTAJE",
  "roster.columns.consent": "CONSENTIMIENTO",
  "roster.notShared": "No compartido",
  "roster.active": "Activo",
  "roster.waitingOnParent": "Esperando a la madre o el padre",
  "roster.lockNote": "El nivel del puntaje (nunca el número) aparece solo si la madre o el padre activó “Compartir el puntaje con esta organización”. Aquí nunca se muestran apellidos, cumpleaños, tareas ni recompensas de la familia. La madre o el padre puede retirar el consentimiento desde la app en cualquier momento; entonces la fila desaparece.",
  "redemptions.title": "Canjes",
  "redemptions.subtitle": "El niño o la niña muestra un código en su dispositivo; tú lo buscas y lo marcas como entregado.",
  "redemptions.lookUp": "Buscar",
  "redemptions.scoreGateMet": "puntaje mínimo alcanzado",
  "redemptions.markFulfilled": "Marcar como entregado",
  "redemptions.notNow": "Ahora no",
  "redemptions.open": "Abrir",
  "redemptions.exportCsv": "Exportar CSV",
  "o03.eyebrow": "NUEVA ASIGNACIÓN",
  "o03.titleSample": "p. ej., Lectura de verano",
  "o03.saveDraft": "Guardar borrador",
  "o03.when": "CUÁNDO",
  "o03.addTask": "+ Agregar tarea",
  "o03.orgApproves": "Aprueba la organización",
  "o03.parentApproves": "Aprueba la madre o el padre",
  "o03.rule": "Regla: todo lo relacionado con la organización lo aprueba tu personal. Una tarea de tipo hogar puede dejar la aprobación a la madre o el padre. Sin tamaños de tarea ni Bamboo Bucks; las tareas cuentan para el Kredit Score del niño o la niña.",
  "o03.reward": "RECOMPENSA",
  "o03.addReward": "+ Agregar recompensa",
  "o03.name": "NOMBRE",
  "o03.unlocksWhen": "SE DESBLOQUEA CUANDO",
  "o03.allTasksDone": "Todas las tareas hechas",
  "o03.alsoRequires": "También requiere un Kredit Score de al menos",
  "o03.checkedOnDevice": "Kiddie Kredit verifica el puntaje por su cuenta, así que funciona aunque la madre o el padre no te haya compartido el puntaje.",
  "o03.assignTo": "ASIGNAR A",
  "o03.pickChildren": "Elegir niños uno por uno",
  "o13.history": "Historial",
  "o13.back": "Volver a la misión",
  "o13.reviewedBefore": "Revisada antes de que existiera el motor",
  "o13.compare": "Comparar",
  "o13.comparing": "Comparando",
  "o13.restore": "Restaurar",
  "o13.hintWithDraft": "Elige una versión para compararla con el borrador, o dos para compararlas entre sí.",
  "o13.hint": "Elige dos versiones para comparar.",
  "o13.noDifferences": "Sin diferencias.",
  "o13.audit": "REGISTRO DE AUDITORÍA · ESTA MISIÓN",
  "o13.copyToDraft": "Copiar al borrador",
  "o11.tabs.story": "Historia",
  "o11.tabs.quiz": "Cuestionario",
  "o11.tabs.history": "Historial",
  "o11.exportJson": "Exportar JSON",
  "o11.takeOver": "Tomar el control",
  "o11.comments": "Comentarios",
  "o11.noComments": "Aún no hay comentarios.",
  "o11.commentOn": "En",
  "o11.commentText": "Comentario",
  "o11.addComment": "Agregar comentario",
  "o11.resolve": "Resolver",
  "o11.resolved": "Resuelto",
  "o11.library": "BIBLIOTECA",
  "o11.draftBanner": "Nada de esto llega a un niño o niña hasta que se revisen ambos guiones y se publique.",
  "o11.missionTitle": "TÍTULO DE LA MISIÓN",
  "o11.levelName": "NOMBRE DEL NIVEL",
  "o11.mechanic": "MECÁNICA",
  "o11.mechanics.story": "Historia",
  "o11.mechanics.picture-quiz": "Cuestionario con imágenes",
  "o11.pointsAt": "LLEVA A",
  "o11.deepLinks.none": "Ninguno",
  "o11.deepLinks.chores": "Tareas",
  "o11.deepLinks.savingsGoal": "Meta de ahorro",
  "o11.deepLinks.kreditScore": "Kredit Score",
  "o11.reader": "LECTOR · SE MUESTRA EN C13",
  "o11.prereader": "PRELECTOR · SE ESCUCHA",
  "o11.listen": "Escuchar ▸",
  "o11.choices": "OPCIONES · SE MUESTRAN EN AMBOS RANGOS",
  "o11.choice": "Opción",
  "o11.consequence": "Consecuencia",
  "o11.readerQuestion": "LECTOR · PREGUNTA",
  "o11.rows.pictures": "Todo imágenes",
  "o11.rows.type": "Todo texto",
  "o11.rows.mixed": "Mixto · corrige antes de publicar",
  "o11.rowNotePictures": "Pies de imagen en caption 17/800.",
  "o11.tiles": "CASILLAS · DE 2 A 4, TODO IMÁGENES O TODO TEXTO",
  "o11.picture": "Imagen",
  "o11.answer": "Respuesta",
  "o11.makeAnswer": "Marcar como respuesta",
  "o11.remove": "Quitar",
  "o11.addTile": "+ Agregar casilla",
  "o11.newTileCaption": "Nueva respuesta",
  "o11.feedback": "COMENTARIO · DESPUÉS DE LA RESPUESTA",
  "o11.close": "Cerrar",
  "o11.gate": "CONTROL DE PUBLICACIÓN",
  "o11.reviewReader": "Guion para lectores · 9–12",
  "o11.reviewPrereader": "Guion para prelectores · 4–8",
  "o11.needsReview": "Falta revisión",
  "o11.nothingToReview": "Nada que revisar",
  "o11.nothingToPublish": "Nada que publicar. Edita cualquier cosa y el control se ejecuta mientras escribes.",
  "o11.warningsTitle": "ADVERTENCIAS · SE MUESTRAN, NUNCA BLOQUEAN",
  "o11.discarded": "Borrador descartado. El editor ahora muestra lo que está publicado.",
  "o11.save": "Guardar el borrador",
  "o11.saveFirst": "Guarda el borrador antes de publicar.",
  "o11.addBeat": "+ Agregar una escena",
  "o11.addChoices": "+ Agregar una opción",
  "o11.removeChoices": "Quitar la opción",
  "o11.addQuestion": "+ Agregar una pregunta",
  "o11.moveUp": "Subir",
  "o11.moveDown": "Bajar",
  "o11.feedbackWrong": "COMENTARIO · SI ES INCORRECTA",
  "o11.learn": "LO QUE APRENDERÁS",
  "o11.learnApproved": "Aprobado · en el recorrido",
  "o11.learnDraft": "Borrador · no está en el recorrido hasta que se apruebe",
  "o11.approve": "Aprobar",
  "o11.withdraw": "Retirar la aprobación",
  "o11.badge": "INSIGNIA",
  "o11.badgeName": "Nombre de la insignia",
  "o11.missions": "MISIONES",
  "o11.deleteMission": "Eliminar",
  "o11.adventureDraft": "Nada de este borrador llega a un niño o niña hasta que se publique la aventura.",
  "o11.learnApprovedPending": "Aprobado · entra al recorrido cuando se publique la aventura",
  "o11.discardDraft": "Descartar borrador",
  "o11.deleteHint": "Solo se puede eliminar una misión que nunca se publicó. Una publicada se retira, para que el recorrido que un niño o niña ya terminó se siga abriendo.",
  "o14.nav": "Biblioteca de íconos",
  "o14.title": "Biblioteca de íconos",
  "o14.search": "Buscar imágenes",
  "o14.nothing": "No hay coincidencias.",
  "o14.unused": "Sin usar",
  "o14.uploadedTag": "Subido",
  "o14.retiredTag": "Retirado",
  "o14.bundled": "Incluido con la app.",
  "o14.uploaded": "Subido desde la biblioteca.",
  "o14.retired": "Retirado: oculto en el selector, pero se sigue mostrando donde ya se usa.",
  "o14.whereUsed": "DÓNDE SE USA",
  "o14.notUsed": "Nada lo usa todavía.",
  "o14.renameUsed": "Una clave no se puede renombrar una vez que el contenido la usa. Renombrar crea una clave nueva más un alias.",
  "o14.renameFree": "Nada la usa todavía, así que la clave aún puede cambiar.",
  "o14.retire": "Retirar",
  "o14.addTitle": "AGREGAR UN ÍCONO",
  "o14.addIntro": "SVG con el contenedor de la Art Reference de Quest Jr.: cuadrícula de 24 × 24, trazos de 2 unidades, extremos y uniones redondeados, sin relleno y tres trazos como máximo. Si una exportación de Figma o Illustrator difiere solo en lo mecánico, el validador prepara la limpieza por ti.",
  "o14.choose": "Elige un archivo SVG",
  "o14.mechanical": "Todas las diferencias son mecánicas. Limpia el archivo y luego revisa el resultado.",
  "o14.redraw": "Hay que volver a dibujarlo. Corrige el dibujo y súbelo de nuevo; no se guardó nada.",
  "o14.cleanUp": "Limpiar el archivo",
  "o14.cleanedUp": "Limpio",
  "o14.whereAppear": "DÓNDE APARECERÁ",
  "o14.previews.tile": "Casilla del cuestionario · 38",
  "o14.previews.badge": "Disco de insignia · 20",
  "o14.previews.unearned": "Sin ganar · 38",
  "o14.previews.enlarged": "Ampliado · 88",
  "o14.key": "CLAVE",
  "o14.keyHelp": "Palabras en minúsculas unidas con guiones, como “dog-bowl”.",
  "o14.add": "Agregar a la biblioteca",
  "o14.cancel": "Cancelar",
  "o14.draftTag": "Borrador",
  "o14.draft": "Un borrador: llega a los teléfonos cuando otro Publicador lo publica.",
  "o14.publish": "Publicar",
  "o14.picture": "Una imagen con relleno. La limpieza deja una sola forma azul marino sobre fondo transparente: no se dibuja nada detrás.",
  "vsq.nav": "Village Square",
  "vsq.title": "Village Square",
  "vsq.subtitle": "Guías, imprimibles, eventos y ofertas para adultos. Cada uno se publica después de una revisión, como una lección.",
  "vsq.kinds.guide": "Guías",
  "vsq.kinds.printable": "Imprimibles",
  "vsq.kinds.event": "Eventos",
  "vsq.kinds.ourProduct": "De Kredit Academy",
  "vsq.kinds.money": "Ayuda con tu dinero",
  "vsq.kinds.partnerOffer": "Ofertas de socios",
  "vsq.status.draft": "Borrador",
  "vsq.status.live": "Publicado",
  "vsq.status.takenDown": "Dado de baja",
  "vsq.newItem": "Nuevo elemento",
  "vsq.edit": "Editar",
  "vsq.save": "Guardar borrador",
  "vsq.cancel": "Cancelar",
  "vsq.review": "Aprobar el texto",
  "vsq.reviewed": "Texto aprobado",
  "vsq.reviewStale": "Cambió desde que se aprobó",
  "vsq.partnerCard": "El socio aprobó el texto",
  "vsq.publish": "Publicar",
  "vsq.takeDown": "Dar de baja",
  "vsq.versions": "Versiones",
  "vsq.restore": "Volver a borrador",
  "vsq.discard": "Descartar borrador",
  "vsq.fields.kind": "Estante",
  "vsq.fields.title": "Título",
  "vsq.fields.line": "Una línea",
  "vsq.fields.provider": "De quién es",
  "vsq.fields.minAge": "Edad mínima",
  "vsq.fields.maxAge": "Edad máxima",
  "vsq.fields.readers": "Nivel de lectura",
  "vsq.fields.readMinutes": "Minutos de lectura",
  "vsq.fields.body": "Texto: deja una línea en blanco entre párrafos; empieza una línea con ## para un subtítulo",
  "vsq.fields.printable": "Imprimible",
  "vsq.fields.startsAt": "Empieza el",
  "vsq.fields.familyPlusOnly": "Solo para miembros de Family Plus",
  "vsq.fields.linkUrl": "Enlace del botón (https://…; {code} para el código del socio)",
  "vsq.fields.linkLabel": "Texto del botón",
  "vsq.fields.partner": "Socio",
  "vsq.fields.picture": "Imagen (un ícono de la biblioteca)",
  "vsq.fields.printableMinutes": "Minutos que toma",
  "vsq.picks.title": "Selección de la semana",
  "vsq.picks.help": "Una guía o un imprimible por semana, el mismo para todas las familias, a partir del lunes de cada familia. Si no hay selección, o no está publicada, las familias reciben la guía más reciente.",
  "vsq.picks.none": "Sin selección",
  "vsq.picks.nothingLive": "Aún no hay nada publicado para mostrar",
  "vsq.readers.prereader": "Prelectores",
  "vsq.readers.reader": "Lectores",
  "vsq.noPartner": "Sin socio",
  "vsq.partners.nav": "Socios",
  "vsq.partners.title": "Socios",
  "vsq.partners.subtitle": "Un propietario aprueba cada socio y el equipo legal revisa su texto antes de que se publique cualquiera de sus tarjetas. Un código por socio, nunca por familia.",
  "vsq.partners.add": "Agregar socio",
  "vsq.partners.name": "Nombre",
  "vsq.partners.code": "Código de referido",
  "vsq.partners.paysFee": "Nos paga una comisión (muestra la línea de comisión)",
  "vsq.partners.counselChecked": "El equipo legal revisó el texto",
  "vsq.partners.disclosures": "Avisos legales, uno por línea",
  "vsq.partners.approve": "Aprobar socio",
  "vsq.partners.approved": "Aprobado",
  "vsq.partners.notApproved": "No aprobado",
  "vsq.partners.ownersOnly": "Solo un propietario puede agregar o cambiar socios.",
  "vsq.partners.logo": "Logotipo",
  "vsq.partners.uploadLogo": "Subir logotipo (PNG o SVG)",
  "vsq.partners.approveLogo": "Aprobar logotipo",
  "vsq.partners.logoApproved": "Las familias ven este logotipo.",
  "vsq.partners.logoWaiting": "Las familias ven el nombre hasta que apruebes este logotipo.",
  "vsq.partners.save": "Guardar",
  "o18.headline": "Lleva Kiddie Kredit a tu club",
  "o18.intro": "Cuéntanos sobre tu club y nos pondremos en contacto.",
  "o18.fields.clubName": "Nombre del club",
  "o18.fields.contactName": "Nombre de contacto",
  "o18.fields.email": "Correo electrónico",
  "o18.fields.phone": "Teléfono",
  "o18.fields.cityState": "Ciudad y estado",
  "o18.fields.kidsCount": "Cantidad aproximada de niños",
  "o18.fields.kidsAges": "Edades de los niños",
  "o18.fields.orgType": "Tipo de organización",
  "o18.fields.heardFrom": "¿Cómo supiste de nosotros?",
  "o18.fields.website": "Sitio web",
  "o18.orgTypes.school": "Escuela",
  "o18.orgTypes.club": "Club",
  "o18.orgTypes.library": "Biblioteca",
  "o18.orgTypes.faith": "Grupo religioso",
  "o18.orgTypes.other": "Otro",
  "o18.send": "Enviar",
  "o18.tooMany": "Demasiadas solicitudes desde aquí. Vuelve a intentarlo en una hora.",
  "o18.nav": "Solicitudes",
  "o18.title": "Solicitudes",
  "o18.subtitle": "Clubes que pidieron unirse. Al aprobar, se configura el club y se envía un correo a su director.",
  "o18.empty": "Aún no hay solicitudes.",
  "o18.ownersOnly": "Solo un propietario puede leer las solicitudes.",
  "o18.status.new": "Nueva",
  "o18.status.approved": "Aprobada",
  "o18.status.declined": "Rechazada",
  "o18.approve": "Aprobar",
  "o18.decline": "Rechazar",
  "o18.declineConfirm": "¿Rechazar esta solicitud? Recibirán un correo amable y podrán volver a presentarla.",
  "o18.keepIt": "Conservarla",
  "o18.declinedNote": "Rechazada. Se elimina después de 12 meses.",
  "o17.nav": "Equipo",
  "o17.title": "Equipo",
  "o17.subtitle": "Cada rol indica lo que alguien puede hacer con el contenido de Kredit Academy.",
  "o17.email": "Correo electrónico",
  "o17.add": "Agregar al equipo",
  "o17.roles.owner": "Propietario",
  "o17.roles.publisher": "Publicador",
  "o17.roles.writer": "Redactor",
  "o17.roles.reviewer": "Revisor",
  "o17.roles.iconDesigner": "Diseñador de íconos",
  "o17.roles.viewer": "Lector",
  "o17.roleHelp.owner": "Administra el equipo.",
  "o17.roleHelp.publisher": "Revisa y publica.",
  "o17.roleHelp.writer": "Edita borradores, pero no puede publicar.",
  "o17.roleHelp.reviewer": "Lee borradores, comenta y aprueba, pero no puede editar ni publicar.",
  "o17.roleHelp.iconDesigner": "Solo sube íconos.",
  "o17.roleHelp.viewer": "Ve borradores e historial, y no cambia nada.",
  "o17.scope": "Todo el contenido de Kredit Academy",
  "o17.invited": "Invitado · esperando a que inicie sesión",
  "o17.askAnOwner": "Pide a un propietario que te agregue",
  "o17.requested": "Pidió unirse · elige un rol",
  "o17.endsOn": "El acceso termina",
  "o17.clearEndsOn": "Sin fecha de fin",
  "o17.companyOnly": "Solo una cuenta de Kredit Academy puede ser propietario o publicador.",
  "o17.confirmTitle": "Confirma tu correo electrónico",
  "o17.confirm": "Confirmar",
  "o17.newCode": "Enviar un código nuevo",
  "o06.title": "Contenido de Quest Jr.",
  "o06.subtitle": "Siete aventuras, dieciocho misiones. Nada de lo que ve un niño o niña cambia hasta que lo publiques.",
  "o06.nav": "Contenido de Quest Jr.",
  "o06.railTitle": "Kiddie Kredit",
  "o06.railSubtitle": "Superadministrador",
  "o06.adventures": "AVENTURAS",
  "o06.missionsIn": "MISIONES DE ESTA AVENTURA",
  "o06.mappedConcept": "Concepto asociado",
  "o06.source": "FUENTE · KREDIT QUEST",
  "o06.sourceChanged": "La lección de origen cambió desde que esto se publicó. Nada se vuelve a publicar por sí solo.",
  "o06.noSource": "Escrito aquí, no importado.",
  "o06.readerScript": "GUION PARA LECTORES · 9–12",
  "o06.prereaderScript": "GUION PARA PRELECTORES · 4–8",
  "o06.reviewed": "Revisado",
  "o06.needsReview": "Falta revisión",
  "o06.markReviewed": "Marcar como revisado",
  "o06.undoReview": "Deshacer revisión",
  "o06.addQuizItem": "+ Agregar pregunta",
  "o06.publish": "Publicar",
  "o06.unpublish": "Quitar del recorrido",
  "o06.retire": "Retirar",
  "o06.newAdventure": "Nueva aventura",
  "o06.newMission": "Nueva misión",
  "o06.sync": "Revisar la fuente",
  "o06.picture": "IMAGEN",
  "o06.noPicture": "Sin imagen: la casilla muestra su respuesta como texto",
  "o06.pickPicture": "Elige una imagen",
  "o06.searchGlyphs": "Buscar imágenes",
  "o06.pickerHelper": "Las imágenes vienen del registro de la app. Se rechaza cualquier nombre que la app no dibuje, para que una casilla nunca muestre algo incorrecto sin avisar.",
  "o06.answerTile": "RESPUESTA",
  "o06.caption": "PIE DE IMAGEN",
  "o06.cannotPublish": "Primero hay que revisar ambos guiones",
  "o06.adminOnly": "El contenido de Quest Jr. es solo para el personal de Kiddie Kredit.",
  "o06.empty": "Aún no hay aventuras.",
  "o06.draft": "Borrador",
  "o09.title": "Invitar familias",
  "o09.subtitle": "La madre o el padre elige qué niños se unen y da su consentimiento en su propio teléfono. Nada aparece en la lista hasta que lo haga.",
  "o09.send": "ENVIAR UNA INVITACIÓN",
  "o09.emails": "Correos de madres o padres",
  "o09.emailsHelper": "uno por línea, o pega una lista",
  "o09.noAccountHint": "Nunca te decimos si una dirección ya tiene una cuenta de Kiddie Kredit.",
  "o09.joining": "Se une a",
  "o09.note": "Agrega una línea propia (opcional)",
  "o09.sent": "ENVIADAS",
  "o09.expiry": "Vencen a los 30 días",
  "o09.resend": "Reenviar",
  "o09.explainer": "Invitado significa que el correo se envió. No significa que lo abrieron ni que tienen una cuenta. Solo Unido pone a un niño o niña en tu lista.",
  "o09.empty": "Aún no se enviaron invitaciones.",
  "o08.title": "Configuración",
  "o08.subtitle": "Cómo ven las familias a tu club y quién puede actuar en su nombre.",
  "o08.club": "EL CLUB",
  "o08.fullName": "NOMBRE COMPLETO",
  "o08.shortForm": "NOMBRE CORTO",
  "o08.badgeLetters": "LETRAS DE LA INSIGNIA",
  "o08.namesHelper": "El nombre completo en la pantalla de consentimiento, el nombre corto en la configuración de la madre o el padre y las letras en la insignia del niño o la niña.",
  "o08.inviteStaff": "Invitar a un miembro del personal",
  "o08.name": "NOMBRE",
  "o08.role": "ROL",
  "o08.remove": "Quitar",
  "o08.removalHelper": "Quitar a alguien termina su acceso de inmediato. Las tareas que aprobó se conservan y los niños mantienen su historial.",
  "o08.groupsAndCodes": "GRUPOS Y CÓDIGOS DE INGRESO",
  "o08.newGroup": "Nuevo grupo",
  "o08.newCode": "Nuevo código",
  "o05.signedInAs": "Sesión iniciada como",
  "o05.title": "Grupos y códigos de ingreso",
  "o05.subtitle": "La madre o el padre escribe el código en la recepción; da su consentimiento por cada niño y luego el niño o la niña aparece en el grupo.",
  "o05.newGroup": "Nuevo grupo",
  "o05.joinCode": "CÓDIGO DE INGRESO",
  "o05.revoke": "Revocar",
  "o05.noCode": "No hay un código activo. Aún puedes invitar a los niños por correo desde la Lista de niños.",
  "o05.generateCode": "Generar código",
  "o05.info.staff": "Personal",
  "o05.info.branches": "Sedes",
  "o05.info.codes": "Códigos",
  "o05.role.groupAdmin": "admin. de grupo",
  "o05.role.orgAdmin": "admin. de la organización",
  "phone.proofNote": "nota",
  "phone.proofPhoto": "foto",
  "phone.code": "Código",
  "states.notStaff.title": "Esta cuenta no pertenece a ningún club",
  "states.notStaff.body": "El portal de clubes de Kiddie Kredit es para el personal de organizaciones asociadas. Si eres madre o padre, todo lo que necesitas está en la app de Kiddie Kredit.",
  "states.notStaff.howToGetAccess": "Si trabajas en un club, pide a tu director que invite a este correo electrónico.",
  "states.notStaff.other": "Iniciar sesión con otra cuenta",
  "states.notKkStaff.title": "Esta sección es para el equipo de Kiddie Kredit",
  "states.notKkStaff.toClubs": "Ir a Clubs",
  "states.notKkStaff.signOut": "Cerrar sesión",
  "states.signInFailed.title": "No pudimos iniciar tu sesión",
  "states.signInFailed.body": "Algo falló de nuestro lado, no del tuyo. Vuelve a intentarlo y, si sigue pasando, escribe a support@kreditacademy.com.",
  "states.signInFailed.cta": "Volver a intentar",
  "states.inviteExpired.title": "Esta invitación venció",
  "states.inviteExpired.body": "Las invitaciones duran 7 días. Pide a quien te invitó que te envíe una nueva.",
  "states.inviteWrongAccount.title": "Esta invitación es para otra persona",
  "states.inviteWrongAccount.cta": "Cerrar sesión",
  "errors.UNAUTHORIZED": "Tu sesión terminó. Vuelve a iniciar sesión.",
  "errors.NOT_FOUND": "Eso ya no existe.",
  "errors.VALIDATION": "Revisa lo que ingresaste y vuelve a intentarlo.",
  "errors.INVALID_STATE": "Alguien más se adelantó. Esto ya se resolvió.",
  "errors.RATE_LIMITED": "Demasiados intentos. Espera un momento y vuelve a intentarlo.",
  "errors.NETWORK": "No se puede conectar con Kiddie Kredit. Revisa tu conexión.",
  "errors.NOT_IMPLEMENTED": "Eso todavía no está activado.",
  "errors.INVALID_CREDENTIALS": "Ese inicio de sesión no funcionó.",
  "errors.other": "Algo falló de nuestro lado, no del tuyo.",
  "signIn.cta": "Iniciar sesión",
  "signIn.email": "Correo electrónico",
  "signIn.panelHeadline": "Kiddie Kredit para clubes",
  "signIn.panelBody": "Dales a los niños de tu programa actividades para hacer y recompensas para ganar, con el consentimiento de sus familias.",
  "signIn.eyebrow": "INICIO DE SESIÓN DEL PERSONAL",
  "signIn.heading": "Inicia sesión en tu club",
  "signIn.body": "Usa el correo electrónico al que te invitó tu club.",
  "signIn.continue": "Continuar",
  "signIn.noClubQuestion": "¿Trabajas en un club que aún no usa Kiddie Kredit?",
  "signIn.noClubLink": "Contáctanos",
  "signIn.parentQuestion": "¿Eres madre o padre?",
  "signIn.parentLink": "Descarga la app",
  "signIn.emailAddress": "Correo electrónico",
  "signIn.orGoogle": "O continúa con Google",
  "signIn.notCompanyAccount": "Usa tu cuenta de Kredit Academy.",
  "signIn.admin.panelLabel": "ADMINISTRACIÓN DE KIDDIE KREDIT",
  "signIn.admin.panelHeadline": "Las herramientas del equipo",
  "signIn.admin.eyebrow": "EQUIPO DE CONTENIDO",
  "signIn.admin.heading": "Inicia sesión en el editor de contenido",
  "signIn.admin.body": "Tu dirección de Kredit Academy inicia sesión con Google. Cualquier otra persona recibe un código por correo.",
  "signIn.admin.tabTitle": "Iniciar sesión · Administración de Kiddie Kredit",
  "signIn.code.title": "Revisa tu correo",
  "signIn.code.sentTo": "Enviamos un código de 6 dígitos a",
  "signIn.code.cta": "Iniciar sesión",
  "signIn.code.differentEmail": "Usar otro correo",
  "signIn.code.resend": "Enviar un código nuevo",
  "signIn.code.dead": "Ese código ya no funciona. Envía un código nuevo.",
  "signIn.code.wrong": "Ese código no es correcto. Revisa el correo y vuelve a intentarlo.",
  "signIn.signInAgainToPublish": "Pasaron más de 12 horas desde que iniciaste sesión. Vuelve a iniciar sesión para publicar.",
  "signIn.secondPublisher": "Otro Publicador debe publicar esto. Tú hiciste el cambio.",
  "getTheApp.cta": "Descarga la app de Kiddie Kredit",
  "getTheApp.apple": "Descárgalo en el App Store",
  "getTheApp.google": "Disponible en Google Play",
  "denyReasons[0].label": "Inténtalo de nuevo",
  "denyReasons[1].label": "No terminada",
  "denyReasons[2].label": "Día equivocado",
};
